import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "@quintype/components";

import { FaBullhorn, FaTimes } from "react-icons/fa";

import "./mob-tmr-banner.m.css";

const MobTMRBanner = () => {
  const [toShowPopup, setToShowPopup] = useState(true);
  const [isHindi, setIsHindi] = useState(false);

  useEffect(() => {
    setIsHindi(global.location.host.includes("hindi"));
  }, []);

  // const text =
  //   "NL and IFF are independent news organisations funded by readers and informed citizens. FoE Con is an effort to enable conversations around the media and regulatory framework in India. Click here to support the forum.";
  // const link = "/valentine-mystery-box";

  const [text, setText] = useState("");
  const [link, setLink] = useState("/?ref=bottom-ticker");

  const { member, fetchSubscription } = useSelector(state => state);

  useEffect(() => {
    if (!member) {
      setText(
        `Be the Santa for free press this new year. Flat 15% off and free merch with our annual subscription. Use code NEW15. Subscribe`
      );
      setLink("/subscription?ref=bottom-ticker");
    } else {
      if (fetchSubscription.isActive) {
        if (fetchSubscription.isRecurring) {
          setText(
            "Be the Santa for free press. Gift yourself or your friends our New Year hamper. Buy"
          );
          setLink("/christmas-offer?ref=bottom-ticker");
        } else {
          setText(
            "Flat 20% off and exclusive merch with our annual subscription. Use code FLAT20. Extend your subscription"
          );
          setLink("/subscription?ref=bottom-ticker");
        }
      } else if (fetchSubscription.isExpired) {
        setText(
          "Last chance: Get flat 20% and free merch with our annual subscription. Use code LASTCHANCE. Subscribe"
        );
        setLink("/subscription?ref=bottom-ticker");
      } else {
        // case for users who never subscribed
        setText(
          "Last chance: Get flat 20% and free merch with our annual subscription. Use code LASTCHANCE. Subscribe"
        );
        setLink("/subscription?ref=bottom-ticker");
      }
    }
  }, [member, fetchSubscription]);

  if (!toShowPopup || isHindi) {
    return null;
  }

  return (
    <div styleName="wrapper">
      <div styleName="row-wrapper">
        <FaBullhorn />
        <p>
          {text}
          <Link href={link}>now</Link>
        </p>
      </div>
      <div styleName="cancel-btn-div">
        <button styleName="cancel-btn" onClick={() => setToShowPopup(false)}>
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export { MobTMRBanner };
